import React from "react";
import { Form } from 'react-bootstrap'
import Question from '../components/Question'
import BaseComponent from './BaseComponent'
import { IIncidentInfo } from "../classes/Domain";
import { QUOTE_QUESTIONS } from "../AppConstants";
import Utilities from "../classes/Utilities";
import { validationUtils } from "../validation/Validation";

interface IState {
    incidentId: number | null,
    incidentType: string,
    incidentDescription: string,
    incidentMonth: number | null,
    incidentYear: number | null,
    descriptionOptions: Array<string>
}

interface IProps {
    incident: IIncidentInfo,
    index: number,
    onChange(incident: IIncidentInfo, index: number): void,
}

class IncidentInfo extends BaseComponent<IProps, IState> {
	constructor(props: IProps) {
		super(props);

        this.state = {
            incidentId : null,
            incidentType: "",
            incidentMonth: null,
            incidentYear: null,
            descriptionOptions: []
		};

		this.incidentTypeCallbackFunction = this.incidentTypeCallbackFunction.bind(this);
        this.onIncidentMonthChange = this.onIncidentMonthChange.bind(this);
        this.onIncidentYearChange = this.onIncidentYearChange.bind(this);
        this.onIncidentDescriptionChange = this.onIncidentDescriptionChange.bind(this);
        this.getIncident = this.getIncident.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {

        if (nextProps.incident != null && nextProps.incident.id != prevState.incidentId) {
            return {
                ...prevState,
                incidentId: nextProps.incident.id,
                incidentType: nextProps.incident.type,
                incidentMonth: nextProps.incident.month,
                incidentYear: nextProps.incident.year
            };
        }

        return null;
    }

    private getIncident() : IIncidentInfo {
        return {
            id: this.state.incidentId,
            type: this.state.incidentType,
            month: this.state.incidentMonth,
            year: this.state.incidentYear,
            description: this.state.incidentDescription
        };
    }

    onIncidentTypeChange(incidentType: string) {
        switch (incidentType) {
            case QUOTE_QUESTIONS.INCIDENTS.TYPES.ACCIDENT:
                this.setState({
                    incidentType,
                    descriptionOptions: [
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.ACCIDENT.AT_FAULT_PD_LESS_1000,
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.ACCIDENT.AT_FAULT_PD_GREATER_1000,
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.ACCIDENT.AT_FAULT_INJURY,
                    ]
                }, () => this.props.onChange(this.getIncident(), this.props.index));
                break;
            case QUOTE_QUESTIONS.INCIDENTS.TYPES.TICKET:
                this.setState({                    
                    incidentType,
                    descriptionOptions: [
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.TICKET.SPEEDING_1_15_OVER_LIMIT,
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.TICKET.SPEEDING_16_34_OVER_LIMIT,
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.TICKET.SPEEDING_35_OVER_LIMIT,
                    ]
                }, () => this.props.onChange(this.getIncident(), this.props.index));
                break;
            case QUOTE_QUESTIONS.INCIDENTS.TYPES.CLAIM:
                this.setState({                    
                    incidentType,
                    descriptionOptions: [
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.CLAIM.THEFT_VANDALISM,
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.CLAIM.LARGE_COMP_CLAIM,
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.CLAIM.SMALL_COMP_CLAIM,
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.CLAIM.UM_UIM_CLAIM,
                        QUOTE_QUESTIONS.INCIDENTS.DESCRIPTION.CLAIM.OTHER
                    ]
                }, () => this.props.onChange(this.getIncident(), this.props.index));
                break;
            default:
                this.setState({                    
                    incidentType,
                    descriptionOptions: []
                }, () => this.props.onChange(this.getIncident(), this.props.index));
                break
        }        
    }

    onIncidentMonthChange(value: string) {
        const month = value ? parseInt(value, 10) : null;
        this.setState({ incidentMonth : month }, () => this.props.onChange(this.getIncident(), this.props.index));
    }

    onIncidentYearChange(value: string) {
        const year = value ? parseInt(value, 10) : null;
        this.setState({ incidentYear: year }, () => this.props.onChange(this.getIncident(), this.props.index));
    }

    onIncidentDescriptionChange(value: string) {
        this.setState({ incidentDescription: value }, () => this.props.onChange(this.getIncident(), this.props.index));
    }

    getIncidentYears() {
        let years = [];
        const currentYear = new Date().getFullYear();
        for (let i = currentYear; i >= currentYear - 5; i--) {
            years.push(i);
        }
        return years;
    }

	render() {
		return (
            <div className="incident-group" key={Utilities.uniqueId()}>
                <div className="incident-group-header"><label>INCIDENT #{this.props.index + 1}</label><a className="remove-incident-icon">Remove <i className="far fa-window-close"></i></a></div>

                <Question
                    name={"incidentType_" + this.props.index}
                    items={[
                        QUOTE_QUESTIONS.INCIDENTS.TYPES.ACCIDENT,
                        QUOTE_QUESTIONS.INCIDENTS.TYPES.TICKET,
                        QUOTE_QUESTIONS.INCIDENTS.TYPES.CLAIM
                    ]}
                    lable="Type"
                    selected={this.onIncidentTypeChange}
                    selectedValue={this.state.incidentType}
                    error={validationUtils.getValidationErrorFor(this.state.errors, "maritalStatus")} />

                <Form.Group className="col-left">
                    <Form.Label>Month</Form.Label>
                    <Form.Control as="select"
                        value={this.state.incidentMonth}
                        onChange={(e) => { this.onIncidentMonthChange(e.target.value) }}>
                        <option value="">Month</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        <option value="4">April</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                    </Form.Control>
                    {
                        //null != this.state.errors && validationUtils.hasValidationErrorFor(this.state.errors, "currentInsuranceCompany")
                        //? <Form.Control.Feedback type="invalid">
                        //    {validationUtils.getValidationErrorFor(this.state.errors, "currentInsuranceCompany")}
                        //</Form.Control.Feedback>
                        //: null
                    }
                </Form.Group>

                <Form.Group className="col-right">
                    <Form.Label>Year</Form.Label>
                    <Form.Control as="select"
                        value={this.state.incidentYear}
                        onChange={(e) => { this.onIncidentYearChange(e.target.value) }}>
                        <option value="">Year</option>
                        {this.getIncidentYears().map((y) => <option key={Utilities.uniqueId()} value={y}>{y}</option>)}
                    </Form.Control>
                    {
                        //null != this.state.errors && validationUtils.hasValidationErrorFor(this.state.errors, "currentInsuranceCompany")
                        //? <Form.Control.Feedback type="invalid">
                        //    {validationUtils.getValidationErrorFor(this.state.errors, "currentInsuranceCompany")}
                        //</Form.Control.Feedback>
                        //: null
                    }
                </Form.Group>

                <Form.Group>
                    <Form.Label>Select the option that best describes the incident </Form.Label>
                    <Form.Control as="select"
                        value={this.state.incidentDescription}
                        disabled={!this.state.incidentType}
                        onChange={(e) => { this.onIncidentDescriptionChange(e.target.value) }}>
                        <option value="">Select</option>
                        {this.state.descriptionOptions.map((o) => <option key={Utilities.uniqueId()} value={o}>{o}</option>)}
                    </Form.Control>
                    {
                        //null != this.state.errors && validationUtils.hasValidationErrorFor(this.state.errors, "currentInsuranceCompany")
                        //? <Form.Control.Feedback type="invalid">
                        //    {validationUtils.getValidationErrorFor(this.state.errors, "currentInsuranceCompany")}
                        //</Form.Control.Feedback>
                        //: null
                    }
                </Form.Group>
            </div>
		);
	}
}

export default IncidentInfo;